export default __webpack_public_path__ + "static/logo-d99693e8c3c9ff162aa712e322de6b26.svg";